module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0021.20c8890a.jpg";